import axiosInstance from "./api/axiosInstance";

/**
 * Busca os dados do relatório de rendimentos para um ano específico.
 * @param {number} year - O ano para o qual o relatório será gerado.
 * @param {string} clientId - O ID do cliente.
 * @returns {Promise<object>} Os dados do relatório.
 */
const getAnnualReport = async (year, clientId) => {
    const config = {
        headers: { "X-Client-ID": clientId }
    };
    const response = await axiosInstance.get(`contract/report/${year}`, config);
    return response.data;
};

/**
 * Faz o download do relatório de rendimentos em formato PDF.
 * @param {number} year - O ano do relatório.
 * @param {string} clientId - O ID do cliente.
 * @returns {Promise<Blob>} O arquivo PDF como um Blob.
 */
const downloadAnnualReportPDF = async (year, clientId) => {
    const config = {
        headers: { "X-Client-ID": clientId },
        responseType: 'blob', // Essencial para receber o arquivo
    };
    const response = await axiosInstance.get(`contract/report/${year}/download`, config);
    return response.data; // Retorna o blob diretamente
};

export const reportService = {
    getAnnualReport,
    downloadAnnualReportPDF,
};